import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="relative rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20background%20with%20golden%20geometric%20patterns%20and%20soft%20light%2C%20luxurious%20amber%20and%20cream%20gradients%2C%20minimalist%20editorial%20style%2C%20premium%20feel%20with%20subtle%20textures%2C%20warm%20inviting%20atmosphere&width=1400&height=400&seq=cta-lottery-bg&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 to-foreground-900/40"></div>
        <div className="relative z-10 px-6 py-12 md:py-16 text-center md:text-left md:flex md:items-center md:justify-between md:px-12">
          <div className="mb-6 md:mb-0">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              准备好开始您的六合彩之旅了吗？
            </h2>
            <p className="text-background-50/70 text-sm md:text-base max-w-[500px]">
              浏览我们的完整内容库，掌握最新资讯和实用技巧。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/xuanhao-jiqiao"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md font-medium text-sm transition-all whitespace-nowrap text-center"
            >
              学习选号技巧
            </Link>
            <Link
              to="/category/pingtai-pingce"
              className="px-6 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-md font-medium text-sm transition-all whitespace-nowrap text-center"
            >
              查看平台评测
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}